module.exports = __webpack_public_path__ + "img/bars_white.a70aee33.png";